export const TIMEZONE = 'Asia/Singapore';
export const DEFAULT_DATE_FORMAT = 'MMM DD YYYY';
export const DEFAULT_DATETIME_FORMAT = 'MMM DD YYYY, hh:mm a Z';
export const DEFAULT_DATETIME_FORMAT_24_HRS_FORMAT = 'MMM DD YYYY, HH:mm a Z';
export const GO_ZERO_DATE = '0001-01-01T00:00:00Z';
export const EMPTY_TIMESTAMP = '-';
export const SHORT_DATE = 'YYYY-MM-DD';
export const SHORT_DATE_TIME = 'YYYY-MM-DD HH:mm';
export const EXP_ELIGIBLE_FOR_EDITING_CUTOFF_DATE = '2026-04-17';
